export const TOPIC = 'TOPIC';



// WEBPACK FOOTER //
// ./src/store/modules/topic/mutation-types.js